import type { SavedItemsListing } from "../graphql.js";
import type { IExtendedSavedItemData } from "../redux/modules/dashboard.ts";

export function mergeItemToArray(array: any[], newItem: any, indexToMerge: number): any[] {
  return array.map((item, index) => {
    if (indexToMerge !== index) {
      // This isn't the item we care about - keep it as-is
      return item;
    }

    // Otherwise, this is the one we want - return an updated value
    return {
      ...item,
      ...newItem,
    };
  });
}

export function updateSavedItemsData(
  savedItemsData: IExtendedSavedItemData[],
  newItemProps: IExtendedSavedItemData,
  isItemToUpdate: (item: IExtendedSavedItemData) => boolean,
): any[] {
  return savedItemsData.map((item: IExtendedSavedItemData) => {
    return isItemToUpdate(item) ? { ...item, ...newItemProps } : item;
  });
}

export function savedItemsListingExists(savedItemsData: IExtendedSavedItemData, savedItemsListing: SavedItemsListing) {
  return (
    savedItemsData.meta.type === savedItemsListing.type && savedItemsData.meta.subType === savedItemsListing.subType
  );
}

export function updateSavedItemsListingData(
  savedItemsData: IExtendedSavedItemData[],
  savedItemsListing: SavedItemsListing,
  isItemToUpdate: (item: IExtendedSavedItemData) => boolean,
): any[] {
  return savedItemsData.map((item) => {
    return isItemToUpdate(item) ? { ...item, meta: savedItemsListing } : item;
  });
}

export function checkMutatedProps(props, prevProps) {
  Object.keys(props).map((key: string) => {
    if (props[key] !== prevProps[key]) {
      // console.warn("Mutated Prop ", key, " from ", prevProps[key], " to ", props[key]);
    }
  });
}
